import {getEnv} from '../../common/env/env';
import {ItemSeriesDto} from '../../common/shared/api/gateway/ItemSeriesDto.interface';
import {LandingPageVo} from '../../common/shared/api/karina/vo/page/LandingPageVo.interface';
import {getKageUrl} from '../../common/shared/utils/getKageUrl';
import {
  ContentsType,
  Maybe,
  SeriesListViewLandingList,
  User,
} from '../generated/types';
import {createNormalListViewItem} from './NormalListViewItem';
import {createSortOption} from './SortOption';

export function createSeriesListViewLandingList(
  userInfo: Maybe<User>,
  landingPage: LandingPageVo<ItemSeriesDto>,
  id: string,
  page: number
): SeriesListViewLandingList {
  return {
    id,
    isEnd: landingPage.is_end,
    totalCount: landingPage.total_count,
    type: ContentsType.Series,
    list: landingPage.list.map(item =>
      createNormalListViewItem(userInfo, {
        listViewLandingItemSeriesDto: {
          ...item,
          // 랜딩 리스트에서는 요일 메타 정보를 보여주지 않습니다.
          pub_period: undefined,
        },
      })
    ),
    themeKeywordOptList: landingPage.theme_keyword_opt_list?.map(sortOption =>
      createSortOption({filterOptionVo: sortOption})
    ),
    selectedThemeKeywordOpt: landingPage.selected_theme_keyword_opt
      ? createSortOption({
          filterOptionVo: landingPage.selected_theme_keyword_opt,
        })
      : undefined,
    title: landingPage.title,
    topImage: landingPage.top_image
      ? getKageUrl({
          kageId: landingPage.top_image,
          kageUrlPrefix: getEnv().kageUrlPrefix,
          resolution: 'o1',
        })
      : undefined,
    page,
    category: landingPage.list.length
      ? landingPage.list[0].category
      : undefined,
  };
}
